import axios from 'axios';
import { 
    GETDROPDOWNURL
    , GETDROPDOWNSURL
} from './action-constants';

export function getDropDownsList(params, actionType) {
    const JSONURL = GETDROPDOWNSURL;
    return {
        type:  actionType
        , payload: new Promise(( resolve, reject) => {
            /*** this is a get but needs to be a post as the table name is passed in the body of the requrest */
            axios.post( 
                JSONURL
                , params
            )
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            });
        })
    };
}

// export function getDropDown(id, params, actionType, token) {
export function getDropDown(id, params, actionType) {
    const JSONURL = GETDROPDOWNURL + id;
    return {
        type: actionType
        , payload: new Promise(( resolve, reject) => {
            /*** this is a get but needs to be a post as the table name is passed in the body of the requrest */
            axios.post( 
                JSONURL 
                , params
            )
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            });
        })
    };
}

export function addDropDown(params, actionType) {
    const JSONURL = GETDROPDOWNURL ;
    return {
        type: actionType
        , payload: new Promise(( resolve, reject) => {
            axios.post(
                JSONURL 
                , params
            )
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            });
        })
    };
}

export function updateDropDown(id, params, actionType) {
    const JSONURL = GETDROPDOWNURL + id;
    return {
        type: actionType
        , payload: new Promise(( resolve, reject) => {
            axios.put(
                JSONURL
                , params
            )
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            });
        })
    };
}

export function deleteDropDown(id, params, actionType) {
    const JSONURL = GETDROPDOWNURL + id;
    return {
        type: actionType
        , payload: new Promise(( resolve, reject) => {
            axios.delete(
                JSONURL
                , { data:params } 
            )
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            });
        })
    };
}